// @ts-strict-ignore
import React from "react";

interface CardProps {
  title?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, action, children }) => {
  return (
    <div
      style={{
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: "12px",
        padding: "32px",
        background: "#fff",
      }}
    >
      {(title || action) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <div style={{ fontWeight: 700 }}>{title}</div>
          {action}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default Card;
